module.exports = __webpack_public_path__ + "img/vip5.a85f8242.jpg";